export default function useWillGetEnergyOrbs(): boolean {
  const luckyNumber = Math.round(1 + Math.random() * 100)
  return luckyNumber >= 1 && luckyNumber <= 50 // always have 50% possibility.
}

export function useEnergyOrbsFromBoss(isCompleted: boolean): number {
  if (isCompleted) {
    return 1
  } else {
    return 5
  }
}
